angular.module("vgresiduos").controller("DestinationGatheringCtrl", [
	"$scope",
	"$state",
	"disposalStepControlService",
	function ($scope, $state, disposalStepControlService) {
		"use strict";

		$scope.model.disposalGatheringIsLocked = false;

		$scope.isTransporterStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.A;
		};

		$scope.isDriverStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.B;
		};

		$scope.isVehicleStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.C;
		};

		$scope.isIntegrationStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.D;
		};

		$scope.isResidueStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.E;
		};

		$scope.isAttachmentStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.F;
		};

		$scope.enableStep = function (stepId) {
			if ($scope.isCurrentStageReview()) {
				return;
			}

			if ($scope.model.disposalGatheringIsLocked) {
				return;
			}

			if (!isStepEnabled(stepId) && !$scope.destinationConfig.blockEnableNextStep) {
				$scope.destinationConfig.enabledStepPointer = stepId;
			}
		};

		$scope.enableBackToStep = function (stepId) {
			if ($scope.isCurrentStageReview()) {
				return;
			}

			if ($scope.model.disposalGatheringIsLocked) {
				return;
			}

			$scope.destinationConfig.enabledStepPointer = stepId;
		};

		function isStepEnabled(stepId) {
			return stepId <= $scope.destinationConfig.enabledStepPointer;
		}

		this.$onInit = function () {
			loadGathering();

			if (gatheringIsLocked()) {
				$scope.model.disposalGatheringIsLocked = !$scope.unlockDisposalGatheringPermission;
				setDisposalGatheringBlockMessage();
				setGatheringIsLockedAlertMessage();
				setDisposalGatheringCustomValidationMessageSteps();
			}
		};

		function gatheringIsLocked() {
			return (
				$scope.destinationModel.LockedGathering &&
				$scope.disposalPreferences.needUnlockDisposalGatheringStage &&
				$scope.destinationModel.Status == Vgr.enumerations.destination.stages.Gathering
			);
		}

		function setDisposalGatheringBlockMessage() {
			const lockedGatheringValidationEnum = Vgr.enumerations.validation.GatheringIsLocked + "";

			let blockMessage = $scope.labels.DISPOSAL_VALIDATIONS_DESCRIPTION_ENUM[lockedGatheringValidationEnum];
			if (!$scope.unlockDisposalGatheringPermission) {
				blockMessage += " " + $scope.labels.CANT_GATHERING;
			}
			$scope.model.disposalGatheringBlockMessage = blockMessage;
		}

		function setGatheringIsLockedAlertMessage() {
			$scope.alertMessages[Vgr.enumerations.destination.alertMessages.gatheringIsLocked] = {
				condition: function () {
					return !$scope.isCurrentStageCompleted() && !$scope.isCurrentStageReview() && $scope.isGatheringStage();
				},
				title: $scope.model.disposalGatheringBlockMessage,
				status: "error"
			};
		}

		function setDisposalGatheringCustomValidationMessageSteps() {
			if (!$scope.model.disposalGatheringIsLocked) {
				return;
			}

			$scope.stagesConfig[$scope.stagesEnum.Gathering].Steps.map(function (item) {
				item.CustomValidationMessage = $scope.model.disposalGatheringBlockMessage;
			});
		}

		function loadGathering() {
			if ($scope.stagesConfig[$scope.stagesEnum.Gathering].load) {
				return;
			}

			$scope.stagesConfig[$scope.stagesEnum.Gathering].load = function () {
				const stageGathering = $scope.stagesEnum.Gathering;
				const stepIntegrations = $scope.stepsEnum.D;

				if ($scope.hasIntegrations()) {
					$scope.stagesConfig[stageGathering].Steps[stepIntegrations].IsDisabled = true;
				}

				if ($scope.isGatheringStage()) {
					setGatheringDate();
					if ($scope.destinationModel.GatheringDate) {
						loadCurrentGatheringStep();
					}
				}
			};

			$scope.$emit(Vgr.constants.evtSetDisposalLoad, true);
		}

		function setGatheringDate() {
			if ($scope.destinationModel.GatheringDate) {
				return;
			}

			const estimatedGatheringDate = $scope.destinationModel.EstimatedGatheringDate;
			if (new Date(estimatedGatheringDate) > Vgr.util.getDate()) {
				$scope.destinationModel.GatheringDate = estimatedGatheringDate;
			} else {
				$scope.destinationModel.GatheringDate = Vgr.util.getDate();
			}
		}

		function loadCurrentGatheringStep() {
			$scope.validateDisposal().then(function () {
				const stepId = disposalStepControlService.determineGatheringStep($scope.validations, $scope);
				setStageStep(stepId);
			});
		}

		function setStageStep(stepId) {
			$scope.destinationConfig.currentStepPointer = stepId;
			$scope.destinationConfig.enabledStepPointer = stepId;
		}
	}
]);
